import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import {Message} from 'iview';
import router from '../router'
import Vuex from 'vuex'
import store from '../store/store'

const axiosIns = axios.create()
if (process.env.NODE_ENV == 'development') { //本地环境
	axiosIns.defaults.baseURL = 'http://www.hxqh.com/';
} else if (process.env.NODE_ENV == 'debug') { //调试环境
	axiosIns.defaults.baseURL = 'http://192.168.2.88:7001/';
} else if (process.env.NODE_ENV == 'production') { // 线上环境
	// axiosIns.defaults.baseURL = 'https://api.ahsjsd.com/'; //线上
	axiosIns.defaults.baseURL = 'https://yapi.ahsjsd.com/'; //线上 复制站
}
axiosIns.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axiosIns.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axiosIns.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
axiosIns.defaults.responseType = 'json';
axiosIns.defaults.timeout = 600000
axiosIns.defaults.validateStatus = function (status) {
	return true;
};
axiosIns.defaults.transformRequest = [
	function (data) {
		return qs.stringify(data);
	}
];
axiosIns.defaults.validateStatus = function (status) {
	return true;
};
// 添加请求拦截器
axiosIns.interceptors.request.use(function (config) {
	let token = store.state.token;
	if (token && token !== 'undefined') config.headers['token'] = token
	return config
}, function (error) {
	Message.error({ background: true, content: '错误的传参' });
	return Promise.reject(error)
})

axiosIns.interceptors.response.use((res) => {
	if (!res.data) {
		return Promise.reject(res)
	}
	return res
}, (error) => {
	return Promise.reject(error)
})
const ajaxMethod = ['get', 'post']
const api = {}
ajaxMethod.forEach((method) => {
	api[method] = function (uri, data, config) {
		return new Promise(function (resolve, reject) {
			axiosIns[method](uri, data, config).then((response) => {
				if (response.data.code === 10000001) {
					window.localStorage.removeItem('token');
					window.localStorage.removeItem('userinfo');
					window.localStorage.removeItem('menu_id');
					store.commit('SET_TOKEN' , '');
					store.commit('SET_USERINFO' , []);
					store.commit('SET_MENU_ID' , '');
					router.push({
						path: "/login",
					});
				}else if (response.data.code === 10000002) {
					Message.error({ background: true, content: response.data.msg });
					router.push({
						path: "/index",
					});
				}else if (response.data.code === 0 || response.data.code === 1 || response.data.code === 10000000) {
					resolve(response.data)
				}
			}).catch(function (error) {
				if (error.response) {
					Message.error({ background: true, content: '服务器无响应' });
				} else {
					Message.error({ background: true, content: '网络故障' });
				}
			})
		})
	}
})
export default api



// WEBPACK FOOTER //
// ./src/utils/http.js